export const aboutData = {
    title: "Who I am",
    description1: "My name's Abhishek. I'm a full stack developer from Indore, Madhya Pradesh.",
    description2: "Web Developer (MERN stack) with 6+ months of experience in designing and developing user interfaces, testing, debugging within eCommerce technologies. Proven ability in optimizing web functionalities that improve data retrieval and workflow efficiencies.",
    image: 2
}